export default "__VITE_ASSET__BnkJfKdE__"